export default __webpack_public_path__ + "static/media/background.f28bb778.jpg";